module.exports = __webpack_public_path__ + "media/images/builder/placeholder-gray-05c04670b3e4320f48c7c76147b25062.jpg";